var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNofamilyfound = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 46,
    viewBox: "0 0 53 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3548 28.5L40.0093 17.6663H12.9907L8.62788 24.1663H8.64783L5.75217 28.4998H20.0002C20.0002 32.0896 22.9103 34.9998 26.5002 34.9998C30.09 34.9998 33.0002 32.0896 33.0002 28.4998L47.3548 28.5ZM52.5 28.5V45.8336H0.5V28.5L10.6809 13.3336H42.3201L52.5 28.5ZM16.568 32.8334H4.83271V41.5H48.1654V32.8334H36.4301C34.7587 36.6594 30.9407 39.3334 26.4981 39.3334C22.0556 39.3334 18.2379 36.6594 16.5661 32.8334H16.568ZM28.6664 8.99979H24.3333V0.333252H28.6664V8.99979ZM39.019 10.3611L35.6478 7.63851L40.8975 1.13851L44.2687 3.86108L39.019 10.3611ZM17.3517 7.63851L13.9805 10.3611L8.73086 3.86108L12.102 1.13851L17.3517 7.63851Z",
    fill: "#7E8899"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNofamilyfound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nofamilyfound.976f2e36a3d6427696a9ab31b030c20c.svg";